import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './ag-grid-styles.css';
import './dropzone.css';
import App from './App';
import { DocViewerPage } from './components/FileViewer';
// import reportWebVitals from './reportWebVitals';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { ThemeProvider } from '@mui/material/styles';
import { GlobalStateProvider, GlobalEventProvider } from './components/GlobalContext'

import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import DateAdapter from '@mui/lab/AdapterDayjs';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

// Check if page was opened in standalone Document Viewer mode (e.g. from new tab)
const searchParams = new URLSearchParams(window.location.search);
const isDocViewer = searchParams.has('docViewer') || searchParams.has('viewFile');

if (isDocViewer) {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DocViewerPage />
    </ThemeProvider>,
    document.getElementById('root')
  );
} else {
  ReactDOM.render(
    <ThemeProvider theme={theme}>
      {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
      <GlobalStateProvider>
        <GlobalEventProvider>
          <CssBaseline />
          <LocalizationProvider dateAdapter={DateAdapter}>
            <App />
          </LocalizationProvider>
        </GlobalEventProvider>
      </GlobalStateProvider>
    </ThemeProvider>,
    document.getElementById('root')
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
